<template>
  <div class="row">
    <div class="col-sm-3" v-for="page in pages" :key="page.name">
      <router-link tag="div" :to="`/admin/reports/${page.path}`" class="card card-admin">
        <div class="card-body text-center">
          <strong>
            {{ page.name }}
          </strong>
          <small class="d-block text-muted mt-1">{{ page.description }}</small>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      pages: [
        { description: 'Volumetria de notas por conta, mês e tipo', name: 'DFe', path: 'dfe' },
      ]
    }),
    name: 'Index',
  }
</script>

<style scoped>

  .card-admin {
    cursor: pointer;
  }
  .card-admin:hover {
    transition: background-color 1s;
    background: #8080803d;
  }
</style>
